var M = /* @__PURE__ */ ((E) => (E.ANONYMOUS = "Anonymous", E.ABO = "BUSINESS_OWNER", E.REGISTERED = "CUSTOMER", E.MEMBER = "MEMBER", E.EMPLOYEE = "EMPLOYEE", E))(M || {}), O = /* @__PURE__ */ ((E) => (E.Employee = "EMPLOYEE", E.MemberPlus = "MEMBER_PLUS", E.Member = "MEMBER", E.Customer = "CUSTOMER", E.BusinessOwner = "BUSINESS_OWNER", E))(O || {});
export {
  O as AccountType,
  M as UserType
};
//# sourceMappingURL=propsType.js.map
